<app-page-header [title]="isMobile ? '' : 'Planning DvdS'" [subtitle]="isMobile ? '' : 'Verkeersmaatregelen'">
    <app-date-indicator [singleDate]="currentDate" (next)="next()" (prev)="prev()" indicator> </app-date-indicator>

    <button class="menu-button" (click)="reload()" print-pdf color="primary" mat-icon-button>
        <mat-icon fontSet="fa-solid" fontIcon="fa-rotate-right"></mat-icon>
    </button>
</app-page-header>
<div class="teams">
    @for (mechanic of mechanics; track mechanic) {
        <div class="team">
            <div class="team-name">
                <div>{{ mechanic.firstname ?? mechanic.name }}</div>
                @if (!mechanic.id) {
                    <div>&nbsp;</div>
                }
                @if (mechanic.id) {
                    <div
                        [class.curpoint]="Features.VkmSaveVehicleSave | hasFeature"
                        (click)="editVehicle(userVehicleMap?.get(mechanic.id), mechanic.id)">
                        <i class="fa-light fa-truck-pickup"></i> {{ userVehicleMap?.get(mechanic.id)?.vehicle }}
                    </div>
                }
            </div>
            <div
                class="team-list"
                id="mechanic-{{ mechanic.id ?? 'null' }}"
                [cdkDropListDisabled]="!(Functionalities.VkmManagement | hasFunctionality)"
                [cdkDropListConnectedTo]="teamLists"
                [cdkDropListData]="mechanic"
                (cdkDropListDropped)="drop($event)"
                cdkDropList
                cdkDropListSortingDisabled>
                @for (planningHas of planningHass | MechanicHasPlanning: mechanic.id : trigger; track planningHas) {
                    <div
                        class="planning curpoint"
                        [cdkDragData]="planningHas"
                        [class.paid]="planningHas['status_key'] === VkmStatus.VkmAfgerekend"
                        [class.second]="(planningHas | mechanicType: mechanic.id : trigger) === 'secondary'"
                        (click)="open(planningHas)"
                        matRipple
                        cdkDrag>
                        @if ((planningHas | mechanicType: mechanic.id : trigger) === 'secondary') {
                            <div class="sec mb-2">
                                Op de bus bij:
                                <u>{{ usersMap?.get(planningHas | mechanicSecondary: mechanic.id : trigger)?.name }}</u>
                            </div>
                        }
                        <b>{{ planningHas.afas_project_id }}</b> - {{ planningHas.type }}<br />
                        <u>{{ planningHas.begindate | date: 'HH:mm' }} - {{ planningHas.enddate | date: 'HH:mm' }}</u
                        ><br />
                        @if (planningHas.location) {
                            <div class="location">
                                <i class="fa-sharp-duotone fa-solid fa-location-dot"></i> {{ planningHas.location }}
                            </div>
                        }
                        <div class="text">
                            {{ planningHas.comment }}
                        </div>
                    </div>
                }
                @if (Functionalities.VkmManagement | hasFunctionality) {
                    <div class="planning-add">
                        <button class="w-100" (click)="add(mechanic)" mat-button color="primary">Toevoegen</button>
                    </div>
                }
            </div>
        </div>
    }
</div>
